module.exports = __webpack_public_path__ + "media/images/country_flags/pl-c114f8e08f0dc15fc77d9548176eda7b.png";